module.exports = __webpack_public_path__ + "static/media/en.3aed38d8.svg";